import styled from "@emotion/styled";

const Button = (props) => {
  const { onClick, disabled = false, children } = props;
  return (
    <StyledButton onClick={onClick} disabled={disabled}>
      {children}
    </StyledButton>
  );
};

/* style */

export default Button;

const StyledButton = styled.button`
  background-color: #006e3d;
  border-radius: 8px;
  border: none;
  padding: 11px 32px;
  color: #ffffff;
  text-transform: uppercase;

  font-family: "Roboto Condensed";
  font-size: 21px;
  line-height: 24px;
  font-weight: 700px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  &:disabled {
    background-color: #8c8c8c;
  }
`;
